export const SubscriptionTypes = {
  full: 'FULL',
  proofs: 'PROOFS',
  fullyPromoted: 'FULLYPROMOTED',
};
